/**
 * One search over the brand's Workshop (⌘K): projects, outputs, ideas and
 * chats the viewer can open, newest first.
 */
import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@/lib/api";

export type WorkshopSearchHit = {
  type: "project" | "output" | "idea" | "chat";
  id: string;
  projectId: string;
  projectName: string;
  title: string;
  /** Outputs only: the document type ("markdown" = none). */
  kind?: string;
  snippet: string;
  archived: boolean;
  updatedAt: string;
};

export function useWorkshopSearch(brandId: string | null, q: string) {
  const term = q.trim();
  return useQuery({
    queryKey: ["workshopSearch", brandId, term],
    queryFn: async () => {
      const res = await axiosInstance.get<{ results: WorkshopSearchHit[] }>(
        `/workshop/brand/${brandId}/search`,
        { params: { q: term } },
      );
      return res.data.results;
    },
    enabled: !!brandId && term.length >= 2,
    staleTime: 30_000,
    placeholderData: (previous) => previous,
  });
}
